import { gql } from '@apollo/client';

export const otpMutation = gql`
  mutation otp {
    otpResponse(input: $input) @rest(type: "ResponseOtp", path: "/customers/code-validate", method: "POST") {
      token
    }
  }
`;
